var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.697 49.4472C194.188 47.9382 192.397 46.7412 190.425 45.9245C188.454 45.1078 186.34 44.6875 184.206 44.6875H123.906C121.213 44.6875 118.629 45.7575 116.725 47.6622C114.82 49.5669 113.75 52.1501 113.75 54.8438C113.75 57.5374 114.82 60.1206 116.725 62.0253C118.629 63.93 121.213 65 123.906 65C121.213 65 118.629 66.07 116.725 67.9747C114.82 69.8794 113.75 72.4626 113.75 75.1562C113.75 76.49 114.013 77.8107 114.523 79.0429C115.034 80.2751 115.782 81.3947 116.725 82.3378C117.668 83.2809 118.787 84.029 120.02 84.5394C121.252 85.0498 122.573 85.3125 123.906 85.3125C121.213 85.3125 118.629 86.3825 116.725 88.2872C114.82 90.1919 113.75 92.7751 113.75 95.4688C113.75 98.1624 114.82 100.746 116.725 102.65C118.629 104.555 121.213 105.625 123.906 105.625H154.375V110.375C154.375 117.599 156.246 124.701 159.806 130.988C163.365 137.275 168.492 142.533 174.688 146.25H207.188V60.9375L195.697 49.4472Z",
    fill: "#3BA6D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.3125H186.875V44.6875H0V20.3125Z",
    fill: "#E0E0DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 20.3125H40.625V44.6875H16.25V20.3125Z",
    fill: "#FFB531"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.875 20.3125H81.25V44.6875H56.875V20.3125Z",
    fill: "#D46C6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 20.3125H121.875V44.6875H97.5V20.3125Z",
    fill: "#60D1E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.688 146.25V170.625H235.625V33.9676C235.625 32.2304 235.253 30.5133 234.535 28.9315C233.817 27.3497 232.769 25.9396 231.461 24.796L206.571 3.01539C204.349 1.07146 201.498 -8.79475e-06 198.546 0H156.406C153.713 0 151.129 1.07003 149.225 2.9747C147.32 4.87936 146.25 7.46265 146.25 10.1562C146.25 12.8499 147.32 15.4331 149.225 17.3378C151.129 19.2425 153.713 20.3125 156.406 20.3125H186.875L207.188 36.5625V81.25L166.562 40.625C165.496 39.558 164.229 38.7116 162.835 38.1341C161.441 37.5566 159.946 37.2594 158.438 37.2594C156.929 37.2594 155.434 37.5566 154.04 38.1341C152.646 38.7116 151.379 39.558 150.312 40.625C149.245 41.692 148.399 42.9587 147.822 44.3528C147.244 45.7469 146.947 47.241 146.947 48.75C146.947 50.259 147.244 51.7531 147.822 53.1472C148.399 54.5413 149.245 55.808 150.312 56.875L178.75 85.3125C173.665 94.2106 170.604 104.12 169.783 114.335C168.962 124.551 170.402 134.821 174 144.417L174.688 146.25V170.625V146.25Z",
    fill: "#4DB7E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.625 170.625V235.625H174.688L182.812 170.625H235.625Z",
    fill: "#FEC9A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M235.625 170.625V182.812H181.289L182.812 170.625H235.625Z",
    fill: "#FEC093"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M186.875 150.312H235.625V158.438H186.875V150.312Z",
    fill: "#3BA6D4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.25 60.9375H125.938C123.694 60.9375 121.875 62.7563 121.875 65C121.875 67.2437 123.694 69.0625 125.938 69.0625H146.25C148.494 69.0625 150.312 67.2437 150.312 65C150.312 62.7563 148.494 60.9375 146.25 60.9375Z",
    fill: "#2D97C4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.375 81.25H125.938C123.694 81.25 121.875 83.0688 121.875 85.3125C121.875 87.5562 123.694 89.375 125.938 89.375H154.375C156.619 89.375 158.438 87.5562 158.438 85.3125C158.438 83.0688 156.619 81.25 154.375 81.25Z",
    fill: "#2D97C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 235.625H16.25C14.0951 235.625 12.0285 234.769 10.5048 233.245C8.98102 231.722 8.125 229.655 8.125 227.5V121.875H105.625V227.5C105.625 229.655 104.769 231.722 103.245 233.245C101.722 234.769 99.6549 235.625 97.5 235.625Z",
    fill: "#E0E0DE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 93.4375H113.75V121.875H0V93.4375Z",
    fill: "#348FD9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 105.625H20.3125V121.875H12.1875V105.625Z",
    fill: "#2D7DBF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4375 105.625H36.5625V121.875H28.4375V105.625Z",
    fill: "#2D7DBF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6875 105.625H52.8125V121.875H44.6875V105.625Z",
    fill: "#2D7DBF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9375 105.625H69.0625V121.875H60.9375V105.625Z",
    fill: "#2D7DBF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1875 105.625H85.3125V121.875H77.1875V105.625Z",
    fill: "#2D7DBF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4375 105.625H101.562V121.875H93.4375V105.625Z",
    fill: "#2D7DBF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 162.5H105.625V227.5C105.625 229.655 104.769 231.722 103.245 233.245C101.722 234.769 99.6549 235.625 97.5 235.625H16.25C14.0951 235.625 12.0285 234.769 10.5048 233.245C8.98102 231.722 8.125 229.655 8.125 227.5V162.5Z",
    fill: "#FFB531"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8125 146.25H105.625V195H52.8125V146.25Z",
    fill: "#A0DDE5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65 174.688H105.625V182.812H65V174.688Z",
    fill: "#8FD0D9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65 158.438H73.125V166.562H65V158.438Z",
    fill: "#8FD0D9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M81.25 158.438H105.625V166.562H81.25V158.438Z",
    fill: "#8FD0D9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 162.5H28.4375V182.812H20.3125V162.5Z",
    fill: "#FFC361"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 134.062H28.4375V142.188H20.3125V134.062Z",
    fill: "#F2F2F2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 150.312H28.4375V162.5H20.3125V150.312Z",
    fill: "#F2F2F2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 121.875H105.625V134.062H8.125V121.875Z",
    fill: "#D9D9D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrine);
export default __webpack_public_path__ + "static/media/Urine.09360cee7e0934f0e3b27bd1ad6e4e94.svg";
export { ForwardRef as ReactComponent };